import { ReactNode } from "react";
import styles from "./Summary.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

function Summary({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className={styles["root"]}>
      <FixaText textStyle={"Body.L"} className={styles["header"]}>
        {t("summaryString")}
      </FixaText>
      <FixaText textStyle={"Body.L"}>{children}</FixaText>
    </div>
  );
}

export default Summary;
